import * as yup from 'yup';
import { useTranslations } from 'hooks/useTranslations';
import { EAuthenticationMethod } from '.';

const useAuthenticationSetupFormSchema = () => {
  const { t } = useTranslations();
  const schema = yup.object({
    numberOfInvalidLoginAttempts: yup
      .string()
      .required(t('general.field.validation.required')),
    timePeriodOfAccountLockout: yup.string().required(t('general.field.validation.required')),
    authenticationMethod: yup
      .string()
      .test(
        'required-validation',
        t('general.field.validation.required'),
        (value, context) => {
          if (context.parent.twoFactorAuthentication === 'false') return true;
          if (context.parent.twoFactorAuthentication === 'true') {
            if (!value || value === EAuthenticationMethod.NONE) return false;
          }
          return true;
        },
      ),
  });

  return { schema };
};

export default useAuthenticationSetupFormSchema;
